import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { fetchEventUsers } from "./adminEventService";
import "./adminEventUsers.css";

/**
 * ===============================
 * SAFE DEBUG LOGGER
 * Shows logs ONLY in development
 * ===============================
 */
const isDev = process.env.NODE_ENV === "development";

const debugLog = (...args) => {
  if (isDev) {
    console.log("[AdminEventUsersPage]", ...args);
  }
};

const debugError = (...args) => {
  if (isDev) {
    console.error("[AdminEventUsersPage]", ...args);
  }
};


const AdminEventUsersPage = () => {

  const { eventId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const eventTitle =
    location.state?.eventTitle || "Event Users";

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);


  /**
   * LOAD USERS
   */
  const loadUsers = async () => {

    try {

      debugLog("Loading users for eventId:", eventId);

      setLoading(true);

      const response =
        await fetchEventUsers(eventId);

      debugLog("API response:", response);

      if (response.status === 200) {

        debugLog("Users loaded successfully:", response.data);

        setUsers(response.data);

      } else {

        debugError("Failed response:", response);

        alert("Failed to load users");

      }

    } catch (error) {

      debugError("Exception while loading users:", error);

      alert("Error loading users");

    } finally {

      setLoading(false);

      debugLog("Loading finished");

    }

  };


  /**
   * PAGE LOAD
   */
  useEffect(() => {

    debugLog("Page mounted");
    debugLog("eventId:", eventId);
    debugLog("eventTitle:", eventTitle);

    loadUsers();

  }, [eventId]);


  return (

    <div className="users-page">

      <div className="users-header">

        <button
          className="back-btn"
          onClick={() => {

            debugLog("Back button clicked");

            navigate(-1);

          }}
        >
          ← Back
        </button>

        <h2>{eventTitle}</h2>

        <div className="user-count">
          Total Users: {users.length}
        </div>

      </div>


      {loading ? (

        <p>Loading users...</p>

      ) : (

        <table className="users-table">

          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>User ID</th>
              <th>Registered At</th>
              <th>Time Zone</th>
            </tr>
          </thead>

          <tbody>

            {users.length === 0 ? (

              <tr>
                <td colSpan="4">
                  No users registered
                </td>
              </tr>

            ) : (

              users.map(user => (

                <tr key={user.id}>

                  <td>{user.name}</td>

                  <td>{user.email}</td>

                  <td>
                    {user.userId || "-"}
                  </td>

                  <td>
                    {new Date(
                      user.registeredAt
                    ).toLocaleString("en-IN")}
                  </td>

                  <td>
                  {user.timeZone || "-"}
                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      )}

    </div>

  );

};

export default AdminEventUsersPage;